$(document).ready(function(){

  $('#switchToSubscription').on('click',function(e){
    e.preventDefault();
    var $t = $(this);
    if ( $t.hasClass('active') ) {
      var newUrl = $t.data('unchecked-url');
      $t.removeClass('active');
    } else {
      var newUrl = $t.data('checked-url');
      $t.addClass('active');
    }
    $t.attr('src',newUrl);
    
    console.log('click');
    $('.rc_radio__autodeliver').click();
    $('#selectField').val(10).trigger('change');
  });

  $('#popupSubscriptionFrequency').on('change', function() {
    console.log( this.value );
    //$(".rc_select__frequency").val( this.value );
    $('.rc-selling-plans__dropdown option').eq(this.value).prop('selected', true);

  });
  $('.dismiss-confirmation').on('click',function(){
    $('body').removeClass('confirmation-open');
  });
  
  $('#switchOneTime').on('click',function(e){
    console.log('popup button clicked');
    e.preventDefault();
    //alert("switch to one time and add to cart");
    $('.rc_widget__option__input--onetime').click();
    $('#addToCart').click();
  });
  
  $('#confirmSubscription').on('click',function(e){
    console.log('popup button clicked');
    e.preventDefault();
    //alert("just add to cart as is");
    $('#addToCart').click();
  });
   
  $('#switchSubscription').on('click',function(e){
    console.log('popup button clicked');
    e.preventDefault();
    //alert("switch to subscriptions and add to cart");
    $('.rc_widget__option__input--subsave').click();
    $('#addToCart').click();
  });
  
  $('#confirmOneTime').on('click',function(e){
    console.log('popup button clicked');
    e.preventDefault();
    //alert("just add to cart as is");
    $('#addToCart').click();
  });
  
  $('#addToCartFake').on('click',function(e){
    console.log($(this));
    e.preventDefault();
    if ( $('.rc-widget').length && !$(this).hasClass('disabled-fake-atc') ) {
      $('body').addClass('confirmation-open');
      $('.rc-radio').each(function(){
        console.log($(this));
        /* if ( $(this).is(':checked') ) { */
        if ( $(this).hasClass('rc-option--active') ) {
          if ( $(this).hasClass('rc-option__subsave') ) {
            $('#subscriptionConfirmPopup').addClass('subscription-selected').removeClass('onetime-selected');
          } else {
            $('#switchToSubscription').removeClass('active');
            $('#switchToSubscription').attr('src',$('#switchToSubscription').data('unchecked-url'));
            $('#subscriptionConfirmPopup').addClass('onetime-selected').removeClass('subscription-selected');
          }
        }
      });
    } else {
      $('#addToCart').click();
    }
  });
  
});